import { useEffect } from 'react';
import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { useRouter, type ErrorComponentProps } from '@tanstack/react-router';
import { RotateCw } from '@/lib/icons';
import { captureException } from '@/lib/observability';
import { errorMessage, isConnectivityError } from '@/lib/api/errors';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/surface';

/** A route that failed to load: say what happened in plain words, offer a retry. */
export function RouteError({ error }: ErrorComponentProps) {
  const router = useRouter();
  const queryReset = useQueryErrorResetBoundary();
  useEffect(() => {
    if (!isConnectivityError(error)) captureException(error, { boundary: 'route' });
  }, [error]);
  useEffect(() => queryReset.reset(), [queryReset]);

  return (
    <div className="grid min-h-[70dvh] place-items-center px-4">
      <Card className="flex max-w-md flex-col items-center gap-4 p-8 text-center">
        <img src="/draper/state-aha-still.webp" alt="" className="size-20" />
        <div>
          <h1 className="text-[18px] font-semibold text-ink">This page didn't load</h1>
          <p className="mt-1.5 text-[14px] text-ink-3">{errorMessage(error)}</p>
        </div>
        <Button variant="primary" onClick={() => void router.invalidate()}>
          <RotateCw />
          Try again
        </Button>
      </Card>
    </div>
  );
}
